import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomeView,
    },
    {
      path: '/settings',
      name: 'settings',
      component: () => import('../views/SettingsView.vue'),
    },
    {
      path: '/import',
      name: 'import',
      component: () => import('../views/ImportView.vue'),
    },
    {
      path: '/kanjis',
      name: 'kanjis',
      component: () => import('../views/KanjisView.vue'),
    },
    {
      path: '/kanjis/:kanji',
      name: 'kanji',
      component: () => import('../views/EditKanjiView.vue'),
    },
    {
      path: '/exercises',
      name: 'exercises',
      component: () => import('../views/ExercisesView.vue'),
    },
    {
      path: '/exercises/create',
      name: 'create-exercise',
      component: () => import('../views/CreateExerciseView.vue'),
    },
    {
      path: '/exercises/:exerciseId/edit',
      name: 'edit-exercise',
      component: () => import('../views/EditExerciseView.vue'),
    },
    {
      path: '/exercises/:exerciseId',
      name: 'exercise',
      component: () => import('../views/ExerciseView.vue'),
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'notfound',
      component: () => import('../views/NotFoundView.vue'),
    },
  ],
})

export default router
